module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("2k6cw"))).then(() => parcelRequire('gP4kF'));